export default __webpack_public_path__ + "static/P_SearchThumb_InfraredSpotlights-b8ef262a0afcc096cee2019ef05f0f1b.webp";